import { render, staticRenderFns } from "./ProgramCard.vue?vue&type=template&id=693ede60"
import script from "./ProgramCard.vue?vue&type=script&lang=ts"
export * from "./ProgramCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports